import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const ProductGpuPage = lazy(() => import('../pages/product-gpu/page'));
const ProductRamPage = lazy(() => import('../pages/product-ram/page'));
const ProductCpuPage = lazy(() => import('../pages/product-cpu/page'));
const ProductPrivacyFilmPage = lazy(() => import('../pages/product-privacy-film/page'));
const ProductPeripheralsPage = lazy(() => import('../pages/product-peripherals/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/product/detail',
    element: <ProductDetailPage />,
  },
  {
    path: '/product/gpu',
    element: <ProductGpuPage />,
  },
  {
    path: '/product/ram',
    element: <ProductRamPage />,
  },
  {
    path: '/product/cpu',
    element: <ProductCpuPage />,
  },
  {
    path: '/product/privacy-film',
    element: <ProductPrivacyFilmPage />,
  },
  {
    path: '/product/peripherals',
    element: <ProductPeripheralsPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
